module.exports = __webpack_public_path__ + "static/media/mandibular-set2dev.a81db351.png";